import { PanelBottom, PanelRight, PanelTop } from "lucide-react";

import { Button } from "@src/shared/components/ui/button";

/** Where a docked panel currently sits relative to the note. */
export type DockPlacement = "right" | "stacked";

export interface PanelDockToggleProps {
  /** Panel name for the accessible label, for example `agenda`. */
  panelName: string;
  placement: DockPlacement;
  /** Side this panel stacks on when it leaves the rail. */
  stackedSide: "top" | "bottom";
  onToggle: () => void;
}

/**
 * Moves a panel between the right rail and the note column. The design gives the
 * agenda and the codes panels their own dock control, and the icon shows where
 * the panel will land rather than where it is now.
 */
export function PanelDockToggle({
  panelName,
  placement,
  stackedSide,
  onToggle,
}: PanelDockToggleProps) {
  const isDockedRight = placement === "right";
  const targetSide = isDockedRight ? stackedSide : "right";
  const Icon = isDockedRight
    ? stackedSide === "top"
      ? PanelTop
      : PanelBottom
    : PanelRight;

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="size-7 shrink-0 rounded-md text-muted-foreground"
      aria-label={`Dock ${panelName} to ${targetSide}`}
      onClick={onToggle}
    >
      <Icon className="size-3.5" aria-hidden />
    </Button>
  );
}
